import React, { Component, Fragment } from 'react';
import { elements } from './_data_safety_layout';
import DayOthersElement from './DayOthersElement';
import './styles/others-layout.css';
import dayjs from 'dayjs';

class OthersLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 4, 'fac');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);

      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0 || dateNum == today.get('date'))) {
        return 'emtpy_state';
      }

      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countOtherIssueTotal || issueOfDay.countOtherIssueTotal <= 0) {
        return 'green_state';
      }

      return 'yellow_state';
    }

    return 'emtpy_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayOthersElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-others">
          {/* Elements 1-4 */}
          {this.populateElements(1, 32)}
          {/* Information Table */}
        </div>
        <h3 className="center" style={{ paddingLeft: '50px', marginTop: '20px' }}>
          Others
        </h3>
      </>
    );
  }
}

export default OthersLayout;
